import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import Button from '@components/Button'
import WarningIcon from '@components/Icon/Warning'
import InfoBox from '@components/InfoBox'
import LogInCt from './LoginCt'

const REDIRECT_TIME_OUT = 20000
class Login extends Component {
  static propTypes = {
    userStore: PropTypes.object
  }

  state = { error: null }

  componentDidMount(){
    let authRedirectLoop = JSON.parse(localStorage.getItem("auth-redirect-loop")||"{}")
    if(!authRedirectLoop.ctr || new Date().getTime() - authRedirectLoop.time > REDIRECT_TIME_OUT){
      authRedirectLoop.ctr = 0
      authRedirectLoop.time = 0
    }
    if(authRedirectLoop.ctr && authRedirectLoop.ctr > 3){
      if(new Date().getTime() - authRedirectLoop.time < REDIRECT_TIME_OUT){
        // eslint-disable-next-line no-console
        console.warn("redirect loop detected")
        this.setState({error:true})
        localStorage.removeItem("auth-redirect-loop")
        return
      }
    }
    authRedirectLoop.ctr++
    authRedirectLoop.time = new Date().getTime()
    localStorage.setItem("auth-redirect-loop",JSON.stringify(authRedirectLoop))
    let u = new URL(window.location.href)
    u.pathname=u.searchParams.get("redirect") || ""
    u.searchParams.delete("redirect")
    window.location = `${process.env.REACT_APP_AUTH_SERVICE_URL}/login?ru=${u.href}`
  }


  render () {
    const {error} = this.state
    return (
      <LogInCt>
          {!error && (
            <h1 className='expert-form-login__title' data-cy='login-title'>
            Redirecting to login page...
            </h1>
          )}
          {error && (
            <div>
              <InfoBox theme={"red"} icon={<WarningIcon />} >
              Redirect Error
              </InfoBox>
              <div style={{margin: 16}}>
              <Button primary block onClick={this.props.userStore.logout}>
                Logout
              </Button>
              </div>
            </div>
          )}
      </LogInCt>
    )
  }
}



export default inject('userStore')(observer(Login))
